<template>
 <div :data-testid="props.dataTestid" :id="random_id" class="h-full">
   <TsCard
       :dataTestid="props.dataTestid+'card'"
       appendClass="border-0 min-h-max shadow-none h-full">
     <TsImage v-if="props.image" :src="props.image" width="30px" loading="lazy"/>
     <TsTypography appendClass="mb-0 mt-4" variant="h3" weight="semibold">Step {{
         props.step
       }}
     </TsTypography>
     <TsTypography >{{ props.text }}</TsTypography>
     <hr v-if="props.step==3" class="my-4"/>
     <slot name="footer">
       <TsCopyTextTag v-if="props.step==3">
         <template #title>
           <TsTypography variant="h3">Address:</TsTypography>
           <TsTooltip :text="props.address" noArrow :hideTooltip=props.hideToolTip>
             <TsIcon size="24" color="grey" name="material-symbols:file-copy-outline"  @click="copyAddress"/>
           </TsTooltip>
         </template>
         <template #content>
           <TsTypography>
             {{ props.address.businessName }} <br>Reply number {{props.address.replyNumber}} <br> {{ props.address.postcode}} {{props.address.city}}
           </TsTypography>
         </template>
       </TsCopyTextTag>
     </slot>

   </TsCard>
 </div>
</template>
<script setup lang="ts">
import {useRandomUUID} from "~/composables/useRandomUUID";
import { toast } from "vue3-toastify";


type Address={
  businessName: string,
  replyNumber: string,
  postcode: string,
  city: string
}
const random_id = ref('')

onMounted(() => {
  random_id.value = useRandomUUID()
})

type Props={
  title?:string,
  address?:Address,
  image?:string,
  copyTitle?:string,
  copyMessage?:string,
  hideToolTip?:boolean,
  step?:string,
  text?:string
  dataTestid:string
}
const props=withDefaults(defineProps<Props>(),{
  address:{
    businessName: "Toolstation",
    replyNumber: "17050",
    postcode: "2650 VK",
    city: "Bleiswijk"}
});

function copyAddress() {
  const addressText = `
${props.address?.businessName}
Reply number ${props.address?.replyNumber}
${props.address?.postcode} ${props.address?.city}
  `.trim();

  navigator.clipboard.writeText(addressText).then(
    () => {
      toast(useTranslation("addressCopied" , "Adres gekopieerd naar klembord!"), {
        autoClose: true,
        type: "success",
      });
    },
    (err) => {
      toast(useTranslation("addressNotCopied" , "Kan adres niet kopiëren"), {
        autoClose: false,
        type: "warning",
      });
    }
  );
}
</script>